import React, { useState, useEffect } from "react";
import { useFormattedMessage } from "hooks";

const messages = {
    searchText: "search_text",
};

const SearchComponent = ({
    className = "",
    inputClassName = "",
    filterText,
    onFilter,
    onClear,
    placeholder,
    small = false,
    isShowSearch = true,
}) => {
    const [text, setText] = useState("");
    const [typingTimer, setTypingTimer] = useState(-1);
    const { formatMessage } = useFormattedMessage();

    useEffect(() => {
        if (filterText != text) {
            setText(filterText);
        }
    }, [filterText]);

    const onChange = (event) => {
        const value = event.target.value;
        setText(value);
        clearTimeout(typingTimer);
        const timer = setTimeout(
            (value) => {
                onFilter(value);
                setTypingTimer(-1);
            },
            1000,
            value
        );
        setTypingTimer(timer);
    };

    const onClearClicked = () => {
        setText("");
        setTypingTimer(-1);
        onClear();
    };

    const textField = {
        height: small ? "40px" : "54px",
        borderRadius: "8px",
        border: "none",
        borderRight: "none",
        padding: "12px 48px",
        fontSize: "14px",
    };

    const clearButton = {
        border: "0",
        fontWeight: 500,
        height: small ? "38px" : "43px",
        width: "32px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        position: "relative",
        top: "50%",
        color: "rgb(171, 171, 171)",
        position: "absolute",
        right: 10,
        transform: "translateY(-50%)",
    };

    const searchIcon = {
        position: "absolute",
        left: "22px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#6A6B7A",
    };
    return (
        <div className={`search-container new-search-container ${className}`}>
            {isShowSearch && <i style={searchIcon} className="fa fa-search" aria-hidden="true" />}
            <input
                style={textField}
                id="search"
                type="text"
                placeholder={placeholder || formatMessage(messages.searchText)}
                value={text}
                onChange={onChange}
                className={`${inputClassName}`}
            />
            {text ? (
                <button style={clearButton} onClick={onClearClicked}>
                    X
                </button>
            ) : null}
        </div>
    );
};
export default SearchComponent;
